import React, { memo } from 'react';
import styled from 'styled-components';
import { TypographyComponent as TypographyElement, Icon, Link } from '@tvg/fuse-design';
import IconLocalOffer from '@tvg/fuse-icons/lib/LocalOffer';

import { renderContent } from 'utilities/content/content-utilities';
import { PromotionVoucher } from 'types/Product';
import analyticsEvent from '../../../services/analytic/analytic-service';

const Container = styled.div`
  display: flex;
  margin-top: var(--spacing-global-space6);
  margin-bottom: var(--spacing-global-space6);
`;

const IconContainer = styled.div`
  flex: 0 0 32px;
`;

const TextContainer = styled.div`
  flex: 1;
  margin-left: var(--spacing-global-space4);
`;

const Apr = styled(TypographyElement)`
  color: var(--color-global-black);
  font-weight: bold;
  margin-top: 1rem;
`;

const InsuranceCardTitle = styled(TypographyElement)`
  color: var(--color-global-black);
  font-weight: bold;
`;

interface InsuranceVoucherCardProps {
  promotionVoucher: PromotionVoucher;
  onClickCallback: () => void;
}

const InsuranceVoucherCard = memo((props: InsuranceVoucherCardProps) => {
  const { promotionVoucher, onClickCallback } = props;
  const onClickHandler = () => {
    onClickCallback();

    analyticsEvent({
      gaAction: 'Product Page - Promotion voucher',
      gaLabel: `${promotionVoucher.type} moreinfo`,
    });
  };

  return (
    <Container data-testid="insurance-voucher-container">
      <IconContainer>
        <Icon icon={<IconLocalOffer />} width="32px" height="32px" dataTestId="insurance-voucher-icon" />
      </IconContainer>
      <TextContainer>
        <InsuranceCardTitle tag="p" type="paragraph" size="1" data-testid="insurance-voucher-title">
          {promotionVoucher.offerTitle}
        </InsuranceCardTitle>

        <TypographyElement tag="p" type="paragraph" size="m1" data-testid="insurance-voucher-text-1">
          {promotionVoucher.offerTerms}
        </TypographyElement>

        <TypographyElement tag="p" type="paragraph" size="m1" data-testid="insurance-voucher-tandc">
          {renderContent('insurance.voucher.card.tandc')}
        </TypographyElement>

        <Link href="#" onClick={onClickHandler} data-testid="insurance-voucher-link" size="medium">
          {renderContent('insurance.voucher.card.link')}
        </Link>

        <Apr size="1" type="paragraph" tag="p" data-testid="insurance-voucher-apr">
          {renderContent('insurance.voucher.card.apr')}
        </Apr>
      </TextContainer>
    </Container>
  );
});

export default InsuranceVoucherCard;
